import { Component } from "@angular/core";

@Component({
  selector: "app-trees-and-shrubs-removal-notification",
  templateUrl: "./trees-and-shrubs-removal-notification.component.html",
  standalone: false,
})
export class TreesAndShrubsRemovalNotificationComponent {}
